import { colorConstants } from 'config/colorConstants';

type FloatingActionCloseIconProps = {
    color?: string;
};

const FloatingActionCloseIcon = ({ color = colorConstants.headerColor }: FloatingActionCloseIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.67085 3.67085C3.89866 3.44305 4.26801 3.44305 4.49581 3.67085L7 6.17504L9.50419 3.67085C9.73199 3.44305 10.1013 3.44305 10.3291 3.67085C10.557 3.89866 10.557 4.26801 10.3291 4.49581L7.82496 7L10.3291 9.50419C10.557 9.73199 10.557 10.1013 10.3291 10.3291C10.1013 10.557 9.73199 10.557 9.50419 10.3291L7 7.82496L4.49581 10.3291C4.26801 10.557 3.89866 10.557 3.67085 10.3291C3.44305 10.1013 3.44305 9.73199 3.67085 9.50419L6.17504 7L3.67085 4.49581C3.44305 4.26801 3.44305 3.89866 3.67085 3.67085Z"
            fill={color}
        />
    </svg>
);

export default FloatingActionCloseIcon;
